import { ButtonTheme, ButtonType } from '@ui-components/PlayButton';
import { UserSurveyFragment } from 'app/graphql/__generated__/types/contento';
import React from 'react';
import { Button, ButtonWrapper } from '../UsabilityTest.styles';
import { IntroHeading } from './Intro.styles';

type Props = {
    onClick: (e: React.MouseEvent) => void;
    onCloseSurvey: (value: string) => void;
    survey: UserSurveyFragment;
};

const Intro = ({ onClick, survey, onCloseSurvey }: Props) => (
    <>
        <IntroHeading>{survey.heading}</IntroHeading>
        <ButtonWrapper>
            <Button
                buttonType={ButtonType.BUTTON}
                theme={ButtonTheme.DEFAULT}
                type="button"
                onClick={() => {
                    onCloseSurvey(survey.id);
                }}
                cancel
            >
                Nej tack
            </Button>

            <Button buttonType={ButtonType.BUTTON} theme={ButtonTheme.WHITE} onClick={onClick}>
                Ja, jag vill testa!
            </Button>
        </ButtonWrapper>
    </>
);

export default Intro;
